import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import iconeFacebook from "../../assets/icons/facebook-color-svgrepo-com.svg";
import iconeWhatsapp from "../../assets/icons/whatsapp-color-svgrepo-com.svg";
import { MdOutlineDeleteForever } from "react-icons/md";
import iconeAdresse from "../../assets/icons/email-envelope-mail-svgrepo-com.svg";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { removeFavorite } from "../../features/favorites/FavoritesSlices";
import SnackbarAlert from "../../components/SnackbarAlert";

const Favoris = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Récupère les Articles favorites depuis le store Redux
  const favoris = useSelector((state) => state.favorites.items);
  const [isLoading, setIsLoading] = useState(true);

  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [snackbarSuccessOpen, setSnackbarOpenSuccess] = useState(false);
  const [snackbarErrorOpen, setSnackbarOpenError] = useState(false);

  const [snackbarPosition, setSnackbarPosition] = useState({
    vertical: "bottom",
    horizontal: "center"
  });
  const { vertical, horizontal } = snackbarPosition;

  const handleCloseSnackbarSuccess = () => {
    setSnackbarOpenSuccess(false);
  };

  const handleCloseSnackbarError = () => {
    setSnackbarOpenError(false);
  };

  useEffect(() => {
    const token = localStorage.getItem("compte_visiteur");
    if (!token) {
      navigate("/");
      return;
    }

    const decodedToken = jwtDecode(token);
    console.log("Token décodé:", decodedToken);
    // Ici, les favoris sont déjà chargés depuis le localStorage
    setIsLoading(false);
  }, [navigate]);

  // Gestion de la suppression d'un favori
  const handleRemoveFavorite = (idPromo) => {
    dispatch(removeFavorite(idPromo));
    setSuccessMessage("La Article a été retirée de vos favoris."); // Ajout du message de succès
    setSnackbarOpenSuccess(true); // Ouvre le Snackbar
  };

  // Génère les liens de partage pour WhatsApp et Facebook
  const generateShareLinks = (promo) => {
    const urlArticle = encodeURIComponent(
      `https://www.godleadershop.ci/product-details/${promo.id}`
    );
    const message = encodeURIComponent(
      `Découvrez cette Article : ${promo.title}`
    );
    return {
      whatsapp: `https://wa.me/?text=${message}%20${urlArticle}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${urlArticle}`
    };
  };

  const formatISODate = (isoDateString) => {
    const date = new Date(isoDateString);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false // utilisation du format 24 heures
    };
    return date.toLocaleString("fr-FR", options);
  };


  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-6">Mes Articles favorits</h1>

        {isLoading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
          </div>
        ) : favoris.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-600">
              Vous n'avez pas encore de Articles favorits.
            </p>
          </div>
        ) : (
          <div className="flex flex-col gap-6">
            {favoris.map((promo) => {
              const { whatsapp, facebook } = generateShareLinks(promo);
              return (
                <>
                  <div
                    key={promo.id}
                    className="flex justify-start flex-col border p-4 gap-y-2 rounded-lg relative"
                  >
                    <div className="flex justify-between h-full relative  flex-row">
                      <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col gap-3">
                        <img
                          src={promo.image}
                          alt=""
                          className="w-44 object-contain h-40 border-2 "
                        />
                        <div className="flex flex-col justify-between ">
                          <div className="flex flex-col justify-start it">
                            <h2 className="text-xl font-bold mb-2">
                              {promo.name}{" "}
                              <span className="text-red-600">
                                -{promo.pourcentageSolde}%
                              </span>
                            </h2>

                            <h2 className="">{promo.marqueName}</h2>
                          </div>

                          <div>
                            <h2 className="text-sm font-semibold ">
                              la Article prend fin le :
                            </h2>
                            {formatISODate(promo.dateFin)}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className=" md:hidden xl:hidden lg:hidden flex flex-col items-start bg-slate-50  justify-end  gap-2  ">
                      <div className="flex flex-row gap-2">
                        <a
                          href={whatsapp}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="  text-black font-semibold bg-slate-200 flex justify-start items-center gap-2  py-2 px-4 rounded"
                        >
                          WhatsApp
                          <img src={iconeWhatsapp} className="w-5" alt="" />
                        </a>
                        <a
                          href={facebook}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-black font-semibold flex bg-slate-200 justify-start items-center gap-2  py-2 px-4 rounded"
                        >
                          Facebook
                          <img src={iconeFacebook} className="w-5" alt="" />
                        </a>
                      </div>
                      <div
                        onClick={() => {
                          navigate(`/product-details/${promo.id}`);
                        }}
                        className="bg-primary py-2 w-full flex items-center justify-center rounded-md"
                      >
                        <h2 className="text-lg font-semibold text-white">
                          Voir Article{" "}
                        </h2>
                      </div>
                    </div>

                    <div className=" hidden md:flex xl:flex lg:flex flex-col items-center bg-slate-50  justify-end absolute bottom-2 right-2 gap-2  ">
                      <div className="flex flex-row gap-2">
                        <a
                          href={whatsapp}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="  text-black font-semibold bg-slate-200 flex justify-start items-center gap-2  py-2 px-4 rounded"
                        >
                          WhatsApp
                          <img src={iconeWhatsapp} className="w-5" alt="" />
                        </a>
                        <a
                          href={facebook}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-black font-semibold flex bg-slate-200 justify-start items-center gap-2  py-2 px-4 rounded"
                        >
                          Facebook
                          <img src={iconeFacebook} className="w-5" alt="" />
                        </a>
                      </div>
                      <div
                        onClick={() => {
                          navigate(`/product-details/${promo.id}`);
                        }}
                        className="bg-primary py-2 w-full flex items-center justify-center rounded-md"
                      >
                        <h2 className="text-lg font-semibold text-white">
                          Voir Article{" "}
                        </h2>
                      </div>
                    </div>
                    <button
                      onClick={() => handleRemoveFavorite(promo.id)}
                      className=" bg-black gap-2 justify-center flex mb-[-0.5rem]  flex-row items-center xl:w-fit lg:w-fit md:w-fit w-full px-11    text-white font-semibold py-1  rounded"
                    >
                      <MdOutlineDeleteForever className="text-xl text-red-600 " />
                      <span className="text-gray-100"> Retirer</span>
                    </button>
                  </div>
                </>
              );
            })}
          </div>
        )}
      </div>

      <SnackbarAlert
        vertical={vertical}
        horizontal={horizontal}
        snackbarSuccessOpen={snackbarSuccessOpen}
        handleCloseSnackbarSuccess={handleCloseSnackbarSuccess}
        successMessage={successMessage}
        snackbarErrorOpen={snackbarErrorOpen}
        handleCloseSnackbarError={handleCloseSnackbarError}
        errorMessage={errorMessage}
      />
    </Layout>
  );
};

export default Favoris;
